import React from 'react';

import SuggestionsSearchFeedback from './SuggestionsSearchFeedback';
import type { OnSuggestionsFeedbackVoteFn } from '../../utils/types';

type SpaceAssetsModalInfoProps = {
  messageComponent: React.ReactNode;
  iconComponent?: React.ReactNode;
  isResponsive?: boolean;
  /** When true (Suggestions mode + latest suggestions asset fetch succeeded), shows footer feedback (thumbs). */
  showSuggestionsFeedback?: boolean;
  onSuggestionsFeedbackVote?: OnSuggestionsFeedbackVoteFn;
};

const SpaceAssetsModalInfo: React.FC<SpaceAssetsModalInfoProps> = (props) => {
  const {
    messageComponent,
    iconComponent,
    isResponsive,
    showSuggestionsFeedback: showFeedback,
    onSuggestionsFeedbackVote,
  } = props;

  const showSuggestionsFeedback = Boolean(showFeedback);

  return (
    <div className="SpaceAssetsModalInfo">
      <div className={`SpaceAssetsModalInfo__content ${isResponsive ? 'SpaceAssetsModalInfo__content--resp_screen' : ''}`}>
        <div className="SpaceAssetsModalInfo__message">{messageComponent}</div>
        {showSuggestionsFeedback ? (
          <>
            <span className="SpaceAssetsModalInfo__divider" aria-hidden="true">
              |
            </span>
            <div className="SpaceAssetsModalInfo__suggestions">
              <SuggestionsSearchFeedback
                isActive={showSuggestionsFeedback}
                isResponsive={isResponsive}
                onVote={onSuggestionsFeedbackVote}
              />
            </div>
          </>
        ) : null}
        {iconComponent ? <div className="SpaceAssetsModalInfo__icon">{iconComponent}</div> : null}
      </div>
    </div>
  );
};

export default SpaceAssetsModalInfo;
